// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"437":"c494f460","615":"7d33d16a","715":"2b558ab7","836":"c494f460","957":"c494f460"}[chunkId] + ".chunk.css";
};